import { useEffect, useMemo, useState } from 'react';
import khConManager from '@src/app/kemuHub/connectionManager';
import { HubConnectionStatus, HubConnectorWithWebAppMethods } from '@src/types/kemuHub/hub_t';

const useKemuHubLink = (): {
  connector: HubConnectorWithWebAppMethods,
  online: boolean,
  status: HubConnectionStatus,
} => {
  const connector = useMemo(() => khConManager.getConnector(), []);
  const [status, setStatus] = useState(() => khConManager.getStatus());

  useEffect(() => {
    const onConnect = () => setStatus('connected');
    const onDisconnect = () => setStatus('disconnected');
    const onAck = () => setStatus('acknowledged');

    khConManager.on('connected', onConnect);
    khConManager.on('disconnected', onDisconnect);
    khConManager.on('acknowledged', onAck);

    return () => {
      khConManager.off('connected', onConnect);
      khConManager.off('disconnected', onDisconnect);
      khConManager.off('acknowledged', onAck);
    };
  }, []);

  const result = useMemo(() => ({
    connector,
    online: status === 'connected' || status === 'acknowledged',
    status,
  }), [connector, status]);

  return result;
};

export default useKemuHubLink;
